import React from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Countries from "./../../../data/countries";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { IoMdAnalytics } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import "./organize-trip.css";
const OrganizeTrip = () => {
  const navigate = useNavigate();
  const ActionHandler = (e) => {
    console.log(e.target.value);
    if (e.target.value === "View") {
      navigate("/organize-trip/view");
    } else if (e.target.value === "Edit") {
      navigate("/organize-trip/create", {
        state: { type: "edit" },
      });
    }
  };
  const State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];
  const [TableData, setTableData] = React.useState([
    {
      createDate: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      startDate: "4 March, 2022",
      endDate: "10 March, 2022",
      tripType: "international",
      price: "$2000",
      status: "Active",
    },
    {
      createDate: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com ",
      phone: "1234567890",
      startDate: "4 March, 2022",
      endDate: "10 March, 2022",
      tripType: "international",
      price: "$2000",
      status: "Active",
    },
    {
      createDate: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      startDate: "4 March, 2022",
      endDate: "10 March, 2022",
      tripType: "international",
      price: "$2000",
      status: "Deactive",
    },
    {
      createDate: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com ",
      phone: "1234567890",
      startDate: "4 March, 2022",
      endDate: "-",
      tripType: "day trip",
      price: "$2000",
      status: "Active",
    },
    {
      createDate: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      startDate: "4 March, 2022",
      endDate: "10 March, 2022",
      tripType: "overnight",
      price: "$2000",
      status: "Deactive",
    },
    {
      createDate: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      startDate: "4 March, 2022",
      endDate: "10 March, 2022",
      tripType: "international",
      price: "$2000",
      status: "Complated",
    },
    {
      createDate: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "HenryOBrien@gmail.com ",
      phone: "1234567890",
      startDate: "4 March, 2022",
      endDate: "-",
      tripType: "day trip",
      price: "$2000",
      status: "Complated",
    },
    {
      createDate: "JAN 4, 2022",
      tripTitle: "Phasellus sagittis eleifend...",
      destination: "Nullam tortor risus, varius...",
      country: "burnside",
      state: "burnside",
      city: "burnside",
      email: "WillowAnderson@gmail.com",
      phone: "1234567890",
      startDate: "4 March, 2022",
      endDate: "10 March, 2022",
      tripType: "overnight",
      price: "$2000",
      status: "Complated",
    },
  ]);
  const handleStatusDropdownChange = (event, tableIndex) => {
    TableData[tableIndex].status = event.target.value;
    setTableData([...TableData]);
  };
  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={10} lg={10} md={10} sm={12} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
              <Button
                className="header-button"
                variant="text"
                onClick={() => {
                  navigate("/organize-trip/create", {
                    state: { type: "add" },
                  });
                }}
              >
                <p className="page-header-button-text">Organize Trip</p>
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={7} xs={12}>
              <div>
                <p className="header-input-heading">Search by Event Title</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by Event Title"
                />
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={5} xs={12}>
              <div>
                <p className="header-input-heading">Role</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search By Role"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Country</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {Countries.map((countriesValue, countriesIndex) => {
                    return (
                      <option key={countriesIndex} value={countriesValue.name}>
                        {countriesValue.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">State</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">city</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={4} xs={12}>
              <div>
                <p className="header-input-heading">Status</p>
                <select className="header-dropdown">
                  <option value="">Select</option>
                  <option value="all">All</option>
                  <option value="Complated">Complated</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={2} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
            <Grid item xl={7} lg={7} md={6} sm={6} xs={12}></Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-header">
            <p className="table-heading">Organize trip</p>
          </div>
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="organize-trip-table-create-date-heading">
                  Create Date
                </th>
                <th className="organize-trip-table-trip-heading">Trip Title</th>
                <th className="organize-trip-table-destination-heading">
                  Destination
                </th>
                <th className="organize-trip-table-country-heading">country</th>
                <th className="organize-trip-table-state-heading">State</th>
                <th className="organize-trip-table-city-heading">City</th>
                <th className="organize-trip-table-email-heading">Email</th>
                <th className="organize-trip-table-phone-number-heading">
                  Phone
                </th>
                <th className="organize-trip-table-start-date-heading">
                  Start Date
                </th>
                <th className="organize-trip-table-end-date-heading">
                  End Date
                </th>
                <th className="organize-trip-table-trip-type-heading">
                  Trip Type
                </th>
                <th className="organize-trip-table-price-heading">price</th>
                <th className="organize-trip-table-status-heading">Status</th>
                <th className="organize-trip-table-action-heading"></th>
                <th className="organize-trip-table-analytics-heading"></th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-date-data">{tableValue.createDate}</td>
                    <td className="table-data">{tableValue.tripTitle}</td>
                    <td className="table-data">{tableValue.destination}</td>
                    <td className="table-data">{tableValue.country}</td>
                    <td className="table-data">{tableValue.state}</td>
                    <td className="table-data">{tableValue.city}</td>
                    <td className="table-email-data">{tableValue.email}</td>
                    <td className="table-data">{tableValue.phone}</td>
                    <td className="table-data">{tableValue.startDate}</td>
                    <td className="table-data">{tableValue.endDate}</td>
                    <td className="table-data">{tableValue.tripType}</td>
                    <td className="table-data">{tableValue.price}</td>
                    <td className="table-data">
                      <select
                        className="table-status-dropdown"
                        style={{
                          backgroundColor:
                            tableValue.status === "Deactive"
                              ? "#FFB0B0"
                              : "#D2FFEB",
                          color:
                            tableValue.status === "Deactive"
                              ? "#B80000"
                              : "#098B51",
                        }}
                        onChange={(e) =>
                          handleStatusDropdownChange(e, tableIndex)
                        }
                      >
                        <option
                          value="Active"
                          selected={
                            tableValue.status === "Active" && "selected"
                          }
                        >
                          Active
                        </option>
                        <option
                          value="Deactive"
                          selected={
                            tableValue.status === "Deactive" && "selected"
                          }
                        >
                          Deactive
                        </option>
                        <option
                          value="Complated"
                          selected={
                            tableValue.status === "Complated" && "selected"
                          }
                        >
                          Complated
                        </option>
                      </select>
                    </td>
                    <td className="table-data">
                      <select
                        className="table-action-dropdown"
                        onChange={ActionHandler}
                      >
                        <option value="">Action</option>
                        <option value="View">View</option>
                        <option value="Edit">Edit</option>
                        <option value="Delete">Delete</option>
                      </select>
                    </td>
                    <td className="table-data">
                      <Button
                        className="table-analytics-chat-button"
                        onClick={() => navigate("/organize-trip/analytics")}
                      >
                        <IoMdAnalytics color="#663399" size={20} />
                      </Button>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default OrganizeTrip;
